
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5tKh7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $jmjWc = parcelRequire("jmjWc");

/* EditorPageCoverPicturePlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $7aRa9 = parcelRequire("7aRa9");

const $4e2549f598bdb9fe$var$Placeholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1isxe5u": (0, $7sObp.default)(`${__cmplp.dynamicCoverImageHeight}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7ysee _2rkofajl _kqswh2mm _1bsb1osq _4t3i1v90",
            __cmplp.className
        ])
    });
});
const $4e2549f598bdb9fe$export$6ab910d41613f405 = (0, $7aRa9.withFlags)((props)=>{
    return props.hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e2549f598bdb9fe$var$Placeholder, null) : null;
});



const $7cc006105e2a4093$export$cc835f6c4a40c9c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6TpAT",
    name: "LazyEditorPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("cxiUA"))).EditorPageCoverPicture;
    },
    loading: (0, $4e2549f598bdb9fe$export$6ab910d41613f405)
});



var $i5zxs = parcelRequire("i5zxs");

// This component is necessary since we only want to check if isTitleHovered/userOffline for pages without cover photos.
// It determines what props will get passed to EditorCoverPicture and renders it.
// Passing the isTitleHovered prop to pages with cover photos causes an unwanted flicker effect if the title is hovered.
// Similarly if we pass userOffline to a page with a cover picture and the page goes offline,
// the image disappears since it is fetched from the media API but there is no internet, causing the image to return as null
const $fdbc267ab6414ddb$var$EditorPageCoverPictureEntryComponent = ({ contentId: contentId, isTitleHovered: isTitleHovered, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, coverPictureState: coverPictureState, isUnpublishedDraft: isUnpublishedDraft, floatingToolbarButtonStyle: floatingToolbarButtonStyle, isFixedWidthImageOption: isFixedWidthImageOption, width: width, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, hasCoverPicture: hasCoverPicture, aiSuggestedUnsplashImages: aiSuggestedUnsplashImages, isUnsplash: isUnsplash, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus })=>{
    // We need this modal state since if there's no cover picture and the modal is open, we don't want to pass the isTitleHovered prop
    // to EditorPageCoverPicture. If passed, this prop causes a bunch of re-renders if the modal is interacted with, making it impossible to
    // use the modal as isTitleHovered keeps getting updated.
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    if (hasCoverPicture) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "has-cover-picture-component",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            position: isFixedWidthImageOption ? 'relative' : 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            left: '0px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            right: '0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7cc006105e2a4093$export$cc835f6c4a40c9c0), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        hasCoverPicture: hasCoverPicture,
        coverPictureState: coverPictureState,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isReadOnly: isReadOnly,
        aiSuggestedUnsplashImages: aiSuggestedUnsplashImages,
        isUnsplash: isUnsplash,
        isFixedWidthImageOption: isFixedWidthImageOption,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId,
        generateAIHeaderImage: generateAIHeaderImage,
        setAIHeaderImageStatus: setAIHeaderImageStatus
    }));
    else if (isModalOpen && !hasCoverPicture) // omit isTitleHovered prop since it causes re-renders if the modal is open and interacted with if the page has no cover picture
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "no-cover-picture-component-modal-open"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7cc006105e2a4093$export$cc835f6c4a40c9c0), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        setIsModalOpen: setIsModalOpen,
        isModalOpen: isModalOpen,
        hasCoverPicture: hasCoverPicture,
        coverPictureState: coverPictureState,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isReadOnly: isReadOnly,
        aiSuggestedUnsplashImages: aiSuggestedUnsplashImages,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId,
        generateAIHeaderImage: generateAIHeaderImage,
        setAIHeaderImageStatus: setAIHeaderImageStatus
    }));
    else // no cover picture and modal isn't open
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "no-cover-picture-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7cc006105e2a4093$export$cc835f6c4a40c9c0), {
        contentId: contentId,
        isTitleHovered: isTitleHovered,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        setIsModalOpen: setIsModalOpen,
        isModalOpen: isModalOpen,
        hasCoverPicture: hasCoverPicture,
        coverPictureState: coverPictureState,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isReadOnly: isReadOnly,
        aiSuggestedUnsplashImages: aiSuggestedUnsplashImages,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId,
        generateAIHeaderImage: generateAIHeaderImage,
        setAIHeaderImageStatus: setAIHeaderImageStatus
    }));
};
const $fdbc267ab6414ddb$export$e8a47c72fec9e984 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdbc267ab6414ddb$var$EditorPageCoverPictureEntryComponent, {
            ...props,
            coverPictureState: coverPictureState
        })));
module.exports["EditorPageCoverPictureEntry"] = $fdbc267ab6414ddb$export$e8a47c72fec9e984;

});

parcelRegister("cxiUA", function(module, exports) {

let $92073c9509f222a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $92073c9509f222a8$var$load("jkPqm"),
    $92073c9509f222a8$var$load("7whwt"),
    $92073c9509f222a8$var$load("f35QR"),
    $92073c9509f222a8$var$load("eVYW1"),
    $92073c9509f222a8$var$load("ls0Um"),
    $92073c9509f222a8$var$load("020xd"),
    $92073c9509f222a8$var$load("eTBsW"),
    $92073c9509f222a8$var$load("bYxCZ"),
    $92073c9509f222a8$var$load("6HBYC"),
    $92073c9509f222a8$var$load("eDqo1"),
    $92073c9509f222a8$var$load("lxiFd"),
    $92073c9509f222a8$var$load("1oiJ6"),
    $92073c9509f222a8$var$load("huUvS"),
    $92073c9509f222a8$var$load("6wr18"),
    $92073c9509f222a8$var$load("98UJI"),
    $92073c9509f222a8$var$load("bTmOC"),
    $92073c9509f222a8$var$load("h4k4y"),
    $92073c9509f222a8$var$load("6vhrJ"),
    $92073c9509f222a8$var$load("kHOMt"),
    $92073c9509f222a8$var$load("hhss7"),
    $92073c9509f222a8$var$load("Wowvf"),
    $92073c9509f222a8$var$load("bRz9K"),
    $92073c9509f222a8$var$load("7EorR"),
    $92073c9509f222a8$var$load("ffEVr"),
    $92073c9509f222a8$var$load("kUbUu"),
    $92073c9509f222a8$var$load("gGhXk")
]).then(()=>parcelRequire('4hoOb'));

});


//# sourceMappingURL=EditorPageCoverPictureEntry.d3f502d4.js.map
